import { oauthToken, oauthTokenProps } from '@/api/server/common/oauth';
import { updatePushToken } from '@/api/server/user/update';
import { localSetStorage, setStorage } from '@/lib/storage';
import { useEffect } from 'react';
import { useCacheBuster } from 'react-cache-buster';
import { useLocation } from 'react-router';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuthInfoActions } from '@/store/zustand/store';
import ErrorRes from '@/api/server/ErrorRes';
import { keepEmail } from '@/component/users/common/keepEmail';

export default function Oauth() {
  const { pathname } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  console.log(`pathname: ${pathname}`);
  console.log(`location: ${JSON.stringify(location)}`);
  console.log(`search: ${location.search}`);
  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const { checkCacheStatus } = useCacheBuster();
  const { setAuthInfo } = useAuthInfoActions();

  useEffect(() => {
    console.log(`useEffect`);
    console.log(code);
    console.log(state);
    if (!code || !state) {
      console.log(`없다.`);
      return;
    }
    (async () => {
      const payload: oauthTokenProps = {
        code,
        state,
      };
      const re = await oauthToken(payload);
      console.log(`result`);
      console.log(re);
      if (re.ret_code === 200) {
        console.log(`return 200`);
        console.log(re);
        checkCacheStatus();
        updatePushToken();
        const payload = {
          key: 'auth',
          value: {
            auth: re.data.auth_token,
            point: re.data.point_token,
            // data
          },
        };
        setAuthInfo(payload.value);
        keepEmail(re.data.email, false, 'oauth', state);
        localSetStorage(payload);
        navigate('/wallet');
      } else if (re.ret_code === 202) {
        // 신규 가입
        const payload = {
          key: 'join',
          value: {
            email: re.data.email,
          },
        };
        setStorage(payload);
        navigate('/agreeTerms');
      } else {
        alert('인증 실패');
        ErrorRes({ code: re.ret_code, msg: re.msg });
      }
    })();

    return () => {};
  }, [code, state]);

  return <></>;
}
